<script lang="ts" setup>
defineProps<{
  loadingText: string | null;
  spinnerName:
    | "bubbles"
    | "circles"
    | "circular"
    | "crescent"
    | "dots"
    | "lines"
    | "lines-small"
    | "lines-sharp"
    | "lines-sharp-small"
    | undefined;
}>();
</script>
<template>
  <Teleport to="body">
    <div class="loading-overlay" slot="fixed">
      <h5 class="loading-overlay-loading-text">
        {{ loadingText || $t("common.loading") }}
      </h5>
      <font-icon
        class="loading-overlay-spinner"
        spin
        name="spinner"
        color="var(--ion-color-primary-tint)"
        size="0.75"
      />
    </div>
  </Teleport>
</template>
<style lang="css">
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--ion-background-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: hidden;
  z-index: 9999;
}
.loading-overlay-loading-text {
  color: var(--ion-text-color);
  margin-top: 10px;
}
.loading-overlay-spinner {
  margin-top: 1rem;
}
</style>
